import { render, staticRenderFns } from "./_systemLogs.vue?vue&type=template&id=99fdd2a2&scoped=true&"
import script from "./_systemLogs.vue?vue&type=script&lang=js&"
export * from "./_systemLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99fdd2a2",
  null
  
)

export default component.exports